module.exports = __webpack_public_path__ + "img/img_xinxishenhe@2x.fe3f690e.png";